import React from "react";
import style from "./DetailItem.module.scss";
import { useTranslation } from "react-i18next";

const DetailItem = ({ label, value }) => {
  const { t } = useTranslation();
  
  return (
    <div className={style.detailItem}>
      <span className={style.label}>{label}:</span>
      <span className={style.value}>{value || t("workOrder.info.notSpecified")}</span>
    </div>
  );
};

export default DetailItem;
